import { Col, Container, Row } from 'react-bootstrap'

export default function DepartmentHeader(props) {
    return (
        <Container className="col-8 p-4 mx-auto text-center" fluid="md">
            <Row>
                <Col md="4">
                    <span className="fs-5 m-3">Department</span>
                </Col>
                <Col md="8">
                    <span className="fs-5 text-muted">{props.text ? props.text : props.department?.name}</span>
                </Col>
            </Row>
        </Container>
    )
}